module.exports = __webpack_public_path__ + "static/img-combo-97d48a26cef06f2e0ed5378fc51b17f3.svg";